var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectParking4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2500,
    height: 1270,
    viewBox: "0 0 2500 1270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "299-300",
    d: "M163 1074H97V842H163V1074Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "305-306",
    d: "M163 723H97V400H163V723Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "291-292",
    d: "M568 1074H499V842H568V1074Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: 312,
    d: "M568 723H502V580H568V723Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: 308,
    d: "M297 723H233V580H297V723Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "283-284",
    d: "M977 1074H903V842H977V1074Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "295-296",
    d: "M293 1074H227V842H293V1074Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "287-288",
    d: "M707 1074H633V842H707V1074Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: 314,
    d: "M707 723H642V580H707V723Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: 310,
    d: "M430 723H368V580H430V723Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "279-280",
    d: "M1113 1074H1034V842H1113V1074Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "277-278",
    d: "M1186 1074H1113V842H1186V1074Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: 276,
    d: "M1249 976H1186V842H1249V976Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: 275,
    d: "M1308 976H1249V842H1308V976Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "273-274",
    d: "M1386 975H1308V744H1386V975Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "271-272",
    d: "M1455 975H1386V744H1455V975Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "263-264",
    d: "M1861 975H1792V744H1861V975Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "255-256",
    d: "M2265 975H2203V744H2265V975Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "241-242",
    d: "M2267 639H2203V396H2267V639Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "233-234",
    d: "M1996 639H1926V396H1996V639Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "221-222",
    d: "M1454 639H1383V396H1454V639Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "211-212",
    d: "M1037 728H974V494H1037V728Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "219-220",
    d: "M1383 639H1312V396H1383V639Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "267-268",
    d: "M1588 975H1519V744H1588V975Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "251-252",
    d: "M2402 975H2334V744H2402V975Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "259-260",
    d: "M1995 975H1926V744H1995V975Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "245-246",
    d: "M2402 639H2334V396H2402V639Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "237-238",
    d: "M2132 639H2063V396H2132V639Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "225-226",
    d: "M1589 639H1522V396H1589V639Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "253-254",
    d: "M2334 975H2265V744H2334V975Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "269-270",
    d: "M1519 975H1455V744H1519V975Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "261-262",
    d: "M1926 975H1861V744H1926V975Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "249-250",
    d: "M2474 975H2402V744H2474V975Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "243-244",
    d: "M2334 639H2267V396H2334V639Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "235-236",
    d: "M2063 639H1996V396H2063V639Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "223-224",
    d: "M1522 639H1454V396H1522V639Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "213-214",
    d: "M1113 728H1037V494H1113V728Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "265-266",
    d: "M1655 975H1588V744H1655V975Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "257-258",
    d: "M2061 975H1995V744H2061V975Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "247-248",
    d: "M2474 639H2402V396H2474V639Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "239-240",
    d: "M2203 639H2132V396H2203V639Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "227-228",
    d: "M1661 639H1589V396H1661V639Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: 218,
    d: "M1312 639H1247V494H1312V639Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: 217,
    d: "M1247 639H1186V494H1247V639Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "215-216",
    d: "M1186 728H1113V494H1186V728Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: 232,
    d: "M1926 639H1861V513H1926V639Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: 230,
    d: "M1795 639H1726V513H1795V639Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: 231,
    d: "M1861 639H1795V513H1861V639Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: 229,
    d: "M1726 639H1659V513H1726V639Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "301-302",
    d: "M97 1074H22V842H97V1074Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "303-304",
    d: "M97 723H22V400H97V723Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "293-294",
    d: "M499 1074H430V842H499V1074Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: 311,
    d: "M502 723H430V580H502V723Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: 307,
    d: "M233 723H163V580H233V723Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "285-286",
    d: "M903 1074H842V842H903V1074Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "297-298",
    d: "M227 1074H163V842H227V1074Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "289-290",
    d: "M633 1074H568V842H633V1074Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: 313,
    d: "M642 723H568V580H642V723Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: 309,
    d: "M368 723H297V580H368V723Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "281-282",
    d: "M1034 1074H977V842H1034V1074Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectParking4);
export default __webpack_public_path__ + "static/media/select-parking-4.ca0f4241.svg";
export { ForwardRef as ReactComponent };